import { HelpToggletip, Tooltip } from 'ui/tooltip';
import { FormField } from 'ui/formField';
import { useFormContext } from 'react-hook-form';
import { CheckboxField } from 'lib/iterable-hook-form';
import { CheckboxDescription, CheckboxRow, LabelRow } from './JwtRequiredField.styled';
import { JWT_REQUIRED } from './ApiKeyModal.constants';

type Props = {
  disableRequireJwt?: boolean;
};

export const JwtRequiredField = ({ disableRequireJwt }: Props) => {
  const { setValue, getValues } = useFormContext();

  const toggleCheckbox = () => {
    const value = getValues(JWT_REQUIRED);
    setValue(JWT_REQUIRED, !value);
  };

  return (
    <FormField
      labelText={
        <LabelRow>
          <label>JWT authentication</label>
          <span>&nbsp;&nbsp;(recommended)</span>
          <HelpToggletip
            iconProps={{ height: 20, width: 20 }}
            tooltipContent="Client-side keys that don't require JWT authentication allow anonymous & unauthenticated API access to your project's data. This security measure is strongly recommended."
          />
        </LabelRow>
      }
    >
      {disableRequireJwt ? (
        <Tooltip tooltipContent="JWT authentication cannot be added to existing API keys.">
          <CheckboxRow>
            <CheckboxField id={JWT_REQUIRED} name={JWT_REQUIRED} isDisabled={true} />
            <CheckboxDescription isDisabled={true}>
              Require that requests made with this API key include a JWT for authentication. API
              keys created with this option cannot be modified.
            </CheckboxDescription>
          </CheckboxRow>
        </Tooltip>
      ) : (
        <CheckboxRow>
          <CheckboxField id={JWT_REQUIRED} name={JWT_REQUIRED} />
          <CheckboxDescription onClick={toggleCheckbox}>
            Require that requests made with this API key include a JWT for authentication. API keys
            created with this option cannot be modified.
          </CheckboxDescription>
        </CheckboxRow>
      )}
    </FormField>
  );
};
